<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
          size="small"
          v-model="searchForm.order_number"
          :clearable="true"
          placeholder="订单号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="客户名称"
          v-model="searchForm.customer_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.customerNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品名称"
          v-model="searchForm.product_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品规格"
          v-model="searchForm.product_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" placeholder="交付状态" v-model="searchForm.status" :clearable="true">
          <el-option label="未交付" value="0"></el-option>
          <el-option label="部分交付" value="2"></el-option>
          <el-option label="全部交付" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchForm.page = 1;getList()"
        >搜索</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <!-- <el-button size="small" icon="el-icon-plus" @click="addProductVisible = true">添加产品</el-button> -->
        <el-button size="small" icon="el-icon-download" v-show="false">另存为Excel</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="customerOrderTable"
      @sort-change="sortChange"
      :data="orderTableData"
      v-loading="orderTableLoading"
      highlight-current-row
      @row-click="row=>{$refs['customerOrderTable'].toggleRowExpansion(row)}"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.productList" :border="true">
            <el-table-column align="center" prop="product_name" label="名称"></el-table-column>
            <el-table-column align="center" prop="product_size" label="规格"></el-table-column>
            <el-table-column align="center" prop="stock_number" label="库存数"></el-table-column>
            <el-table-column align="center" prop="price" label="单价"></el-table-column>
            <el-table-column align="center" prop="count" label="数量"></el-table-column>
            <el-table-column align="center" prop="money" label="金额"></el-table-column>
            <el-table-column align="center" prop="cost_hour" label="工时"></el-table-column>
            <el-table-column align="center" prop="delivered_count" label="已交付数"></el-table-column>
            <el-table-column align="center" prop="delivered_date" label="交付日期" width="100px"></el-table-column>
            <el-table-column align="center" label="操作" width="140px">
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  @click="showDeliver(scope.row)"
                  :disabled="scope.row.count === scope.row.delivered_count"
                >交付</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="primary">修改</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="primary">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="order_number" label="订单号"></el-table-column>
      <el-table-column align="center" prop="customer_name" label="客户名称"></el-table-column>
      <!-- <el-table-column align="center" label="产品信息">
        <el-table-column align="center" prop="product_name" label="名称"></el-table-column>
        <el-table-column align="center" prop="product_size" label="规格"></el-table-column>
        <el-table-column align="center" prop="stock_number" label="库存数"></el-table-column>
        <el-table-column align="center" prop="price" label="单价"></el-table-column>
        <el-table-column align="center" prop="count" label="数量"></el-table-column>
        <el-table-column align="center" prop="money" label="金额"></el-table-column>
        <el-table-column align="center" prop="cost_hour" label="工时"></el-table-column>
        <el-table-column align="center" prop="delivered_count" label="已交付数">
          <template slot-scope="scope">
            <div>
              {{scope.row.delivered_count}}
              <i
                v-if="scope.row.delivered_count"
                @click="showDeliverLog(scope.row)"
                class="el-icon-info"
                style="cursor:pointer;font-size:16px"
              ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="delivered_date" label="交付日期" width="100px"></el-table-column>
        <el-table-column align="center" label="操作" width="140px">
          <template slot-scope="scope">
            <el-link
              type="primary"
              @click="showDeliver(scope.row)"
              :disabled="scope.row.count === scope.row.delivered_count"
            >交付</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary">修改</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link type="primary">删除</el-link>
          </template>
        </el-table-column>
      </el-table-column> -->
      <el-table-column align="center" label="交付状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status === '0'">未交付</div>
          <div v-else-if="scope.row.status === '1'">全部交付</div>
          <div v-else-if="scope.row.status === '2'">部分交付</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="order_money" label="总金额"></el-table-column>
      <el-table-column
        align="center"
        prop="order_date"
        label="下单日期"
        sortable="custom"
        width="110px"
      ></el-table-column>
      <el-table-column align="center" prop="remark" label="备注"></el-table-column>
      <el-table-column align="center" label="操作(订单)" width="170px" fixed="right">
        <template slot-scope="scope">
          <el-link type="primary" @click="showAddProduct">添加产品</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link type="primary" @click="showEditOrder(scope.row)">修改</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link type="primary">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:15px"
      v-if="orderTableTotal"
      @current-change="(page)=>{this.searchForm.page = page;this.getList()}"
      layout="prev, pager, next"
      :total="orderTableTotal"
      align="center"
    ></el-pagination>
  </div>
</template>

<script>
// import { getOrderList } from '../api/index'
export default {
  data () {
    return {
      // 订单列表
      searchForm: {
        order_number: '',
        customer_name: '',
        product_name: '',
        product_size: '',
        status: '',
        sortType: 'order_date',
        order: 'desc',
        page: 1
      },
      orderTableTotal: null,
      orderTableLoading: false,
      orderTableData: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    sortChange (sortInfo) {
      console.log(sortInfo)
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else {
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    showAddProduct () {

    },
    showEditOrder () {

    },
    getList () {
      this.orderTableData = [
        {
          order_number: '20200620001',
          customer_name: '国威',
          status: '0',
          order_money: '1888',
          order_date: '2020-06-19',
          remark: '',
          productList: [
            {
              product_name: '这是品名',
              product_size: '这是规格',
              stock_number: '这是库存数',
              price: '这是价格',
              count: '这是数量',
              money: '这是金额',
              cost_hour: '这是工时',
              delivered_count: '这是已交付数',
              delivered_date: '这是交付日期'
            },
            {
              product_name: '这是品名',
              product_size: '这是规格',
              stock_number: '这是库存数',
              price: '这是价格',
              count: '这是数量',
              money: '这是金额',
              cost_hour: '这是工时',
              delivered_count: '这是已交付数',
              delivered_date: '这是交付日期'
            },
            {
              product_name: '这是品名',
              product_size: '这是规格',
              stock_number: '这是库存数',
              price: '这是价格',
              count: '这是数量',
              money: '这是金额',
              cost_hour: '这是工时',
              delivered_count: '这是已交付数',
              delivered_date: '这是交付日期'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style>
</style>
